import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    marketplaceCategory: null,
    marketplaceCategories: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const marketplaceCategoryReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.MARKETPLACECATEGORY_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.MARKETPLACECATEGORY_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.MARKETPLACECATEGORY_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default marketplaceCategoryReducer;
